import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { loadChatbotStartChat } from '../thunks/chatbotStartChat.thunk';
import { chatActions } from './chat';
import { createState } from './fieldCreaters';
import { IFieldState } from './types';

const initialState: IFieldState = {
  maxLength: -1,
  disabled: false,
  hidden: true,
  placeholder: '',
  value: '',
  attachFile: false,
  multiline: false,
  nodeId: undefined,
  change: false,
};

export const fieldSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    changeValue: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
    updateChatbot: (state, action: PayloadAction<Partial<IFieldState>>) => {
      return createState(action.payload);
    },
    updateLiveChatbot: (state, action: PayloadAction<Partial<IFieldState>>) => {
      state.nodeId = action.payload.nodeId;
      state.placeholder = action.payload.placeholder;
    },
    sendMessage: (state) => {
      state.disabled = true;
      state.value = '';
      state.attachFile = false;
      state.multiline = false;
      state.change = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(chatActions.reset, () => {
      return initialState;
    });
    builder.addCase(loadChatbotStartChat.fulfilled, (state, action) => {
      return createState(action.payload.ui ?? {});
    });
  },
});

export const fieldActions = fieldSlice.actions;
